/* lib/kitchenModeSignal.js — режим «Продукции» (classic | pos) для тех, кто живёт вне её оболочки
   (kitchen-ux E1c).

   Режим решает сервер (GET /api/integrations/ → kitchen_mode), и знает его только оболочка
   раздела (screens/kitchen/KitchenShell.jsx). Тур онбординга живёт выше (AppShell) и выбирает цели
   шагов «Продукции» под режим: в режиме кассы вкладок «Полуфабрикаты» и «Готовые позиции» нет —
   всё в «Черновиках». Оболочка объявляет режим событием окна, когда сервер ответил; тур слушает.
   Модули друг друга не импортируют: оболочке не нужен провайдер тура, провайдеру — оболочка. */

export const KITCHEN_MODE_EVENT = 'kitchen:mode';

const defaultTarget = () => (typeof window !== 'undefined' ? window : null);

/** Объявить режим: всё, кроме 'pos', — 'classic'. Без окна (SSR, тест без DOM) — ничего. */
export function announceKitchenMode(mode, target = defaultTarget()) {
  if (!target || typeof target.dispatchEvent !== 'function') return;
  try {
    target.dispatchEvent(new CustomEvent(KITCHEN_MODE_EVENT, { detail: { mode: mode === 'pos' ? 'pos' : 'classic' } }));
  } catch { /* событие не собралось — режим classic по умолчанию у слушателя */ }
}

/** Режим из события: 'pos' | 'classic'; чужое и мусор — null. */
export function kitchenModeOfEvent(e) {
  const mode = e && e.detail && e.detail.mode;
  return mode === 'pos' || mode === 'classic' ? mode : null;
}
